import { render } from "./Survey2024.vue?vue&type=template&id=bca22b2e"
import script from "./Survey2024.vue?vue&type=script&lang=js"
export * from "./Survey2024.vue?vue&type=script&lang=js"

import "./Survey2024.vue?vue&type=style&index=0&id=bca22b2e&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__